export default __webpack_public_path__ + "static/media/TouchOne.7b943eb1.svg";